<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="8">
        <v-data-table v-if="account" :headers="headers" :items="getCartItems()">
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Exam Registrations in cart</v-toolbar-title>
              <v-spacer></v-spacer>
              <ReturnHomeBtn />
            </v-toolbar>
          </template>

          <template v-slot:item.id="{ item }">
            {{ getSubjectDescription(item.subjectId) }} Grade
            {{ item.gradeLevel }}
            {{ item.isRetry ? "Retry" : "Comprehensive" }} Exam for
            {{ getChildName(item.childId) }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-layout justify-center>
              <v-icon @click="deleteItem(item)">mdi-delete</v-icon>
            </v-layout>
          </template>

          <template v-slot:item.amount="{ item }">
            <v-layout
              justify-end
            >${{ getExamFeeSchoolYear(item.gradeLevel, item.isRetry, item.schoolYearId) }}</v-layout>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="mx-auto" max-width="330">
          <v-card-title>Order Summary</v-card-title>
          <v-card-text>
            <v-row v-if="hstPercent > 0">
              <v-col>Sub-total:</v-col>
              <v-col class="text-end">${{ subTotalAmount.toFixed(2) }}</v-col>
            </v-row>
            <v-row v-if="hstPercent > 0">
              <v-col>HST ({{ hstPercent }}%)</v-col>
              <v-col class="text-end">${{ hstAmount.toFixed(2) }}</v-col>
            </v-row>
            <v-row class="font-weight-bold">
              <v-col>Total:</v-col>
              <v-col class="text-end">${{ calculateTotals().toFixed(2) }}</v-col>
            </v-row>
            <v-row justify="center">
              <AccountCreditChip @getAccountCredit="getAccountCredit($event)" />
            </v-row>
          </v-card-text>
          <v-card-actions v-if="totalAmount !== 0">
            <v-row>
              <v-col cols="12" v-if="accountCredit >= totalAmount">
                <v-dialog v-model="applyCreditDialog" max-width="400">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      block
                      large
                      color="info"
                      v-on="on"
                    >Use ${{ totalAmount.toFixed(2) }} credit</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Confirmation</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col
                            cols="12"
                          >To confirm application of ${{ totalAmount.toFixed(2) }} credit, please enter the amount.</v-col>
                        </v-row>
                        <v-row>
                          <v-text-field
                            :hint="labelTotal(totalAmount)"
                            persistent-hint
                            v-model="confirmAmount"
                          ></v-text-field>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="applyCreditDialog = false">Cancel</v-btn>
                      <v-btn
                        color="primary"
                        @click="applyCredit"
                        :disabled="confirmAmount !== totalAmount.toFixed(2)"
                      >Confirm</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>

              <v-col cols="12" v-else>
                <v-dialog v-model="payDialog" max-width="600" persistent>
                  <template v-slot:activator="{ on }">
                    <v-btn block :large="accountCredit == 0" color="primary" v-on="on">
                      <span class="mr-1" v-if="accountCredit > 0">Use credit &amp;</span>
                      Pay ${{ totalAmount - accountCredit }}
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Credit Card Payment</span>
                    </v-card-title>
                    <v-card-text>
                      <div id="sq-card"></div>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="cancelPay">Cancel</v-btn>
                      <v-btn
                        min-width="150"
                        color="primary"
                        :loading="loading"
                        @click="processPaymentV2($event)"
                      >Pay ${{ totalAmount - accountCredit }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>

              <v-col cols="12" v-if="isAdmin && accountCredit < totalAmount">
                <v-dialog v-model="dialog" max-width="400">
                  <template v-slot:activator="{ on }">
                    <v-btn block :large="accountCredit == 0" color="purple darken-2" dark v-on="on">
                      <span class="mr-1" v-if="accountCredit > 0">Use credit &amp;</span>
                      Mark as Paid
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">Confirmation</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col
                            cols="12"
                          >To confirm payment of ${{ (totalAmount - accountCredit).toFixed(2) }}, please enter the amount.</v-col>
                        </v-row>
                        <v-row>
                          <v-text-field
                            :hint="labelTotal(totalAmount - accountCredit)"
                            persistent-hint
                            v-model="confirmAmount"
                          ></v-text-field>
                        </v-row>
                        <v-row>
                          <v-textarea
                          class="mt-4"
                            counter
                            outlined
                            label="Required Notes"
                            hint="Enter payment reference"
                            :rules="rules"
                            v-model="notes"
                          ></v-textarea>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="dialog = false">Cancel</v-btn>
                      <v-btn
                        color="primary"
                        @click="markAsPaid"
                        :disabled="confirmAmount !== (totalAmount - accountCredit).toFixed(2) || !notes"
                      >Confirm</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ReturnHomeBtn from "../components/ReturnHomeBtn.vue";
import { errorMessageMixin, subjectMixin } from "../shared";
import AccountCreditChip from "../components/AccountCreditChip.vue";

export default {
  name: "CheckOut",
  mixins: [errorMessageMixin, subjectMixin],
  data() {
    return {
      headers: [
        {
          text: "Description",
          value: "id",
          align: "start"
        },
        {
          text: "Amount",
          value: "amount",
          align: "end",
          sortable: false
        },
        {
          text: "Actions",
          value: "actions",
          align: "center",
          sortable: false
        }
      ],
      hstAmount: 0,
      subTotalAmount: 0,
      totalAmount: 0,
      hstPercent: process.env.VUE_APP_HST_PERCENT,
      dialog: false,
      payDialog: false,
      payments: null,
      card: null,
      confirmAmount: "",
      loading: true,
      isPaymentFormBuilt: false,
      accountCredit: 0,
      applyCreditDialog: false,
      notes: "",
      rules: [v => v.length <= 500 || "Max 500 characters"]
    };
  },
  components: { ReturnHomeBtn, AccountCreditChip },
  mounted: async function() {
    this.$store.state.fullScreenLoading = false;
    await this.loadSchoolYears();

    //square payments old start
    // let applicationId = "sandbox-sq0idb-2gfBpDdG56GKjve6FBMCDA";
    // let that = this;
    // console.log("in mounted *****************");
    // // eslint-disable-next-line no-undef
    // this.paymentForm = new SqPaymentForm({
    //   applicationId: process.env.VUE_APP_SQUARE_APP_ID,
    //   autoBuild: false,
    //   card: {
    //     elementId: "sq-card"
    //   },
    //   // Initialize the payment form elements

    //   // SqPaymentForm callback functions
    //   callbacks: {
    //     /*
    //      * callback function: cardNonceResponseReceived
    //      * Triggered when: SqPaymentForm completes a card nonce request
    //      */
    //     cardNonceResponseReceived: function(errors, nonce, cardData) {
    //       if (errors) {
    //         // Log errors from nonce generation to the browser developer console.
    //         console.error("Encountered errors:");
    //         that.$store.state.error = errors[0].message;
    //         errors.forEach(function(error) {
    //           console.error("  " + error.message);
    //         });
    //         that.$store.state.snackbar = true;
    //         that.loading = false;
    //         return;
    //       }
    //       console.log("cardData", cardData);
    //       that.postCardPayment(nonce);
    //     },
    //     paymentFormLoaded: function() {
    //       console.log("payform loaded");
    //       that.loading = false;
    //       that.isPaymentFormBuilt = true;
    //     }
    //   }
    // });

    // console.log("this.paymentForm", this.paymentForm);
    //square payments old end
    
  },
  watch: {
    payDialog: function() {
      if (!this.payDialog) {
        //detach cc form
        this.detachForm();
        return 1;
      }
      //attach cc form
      this.attachForm();
      
      //square payments old
      // if (!this.isPaymentFormBuilt) {
      //   this.paymentForm.build();
      // }
    }
  },
  computed: {
    ...mapState(["account", "examFees", "schoolYear", "schoolYears"]),
    ...mapGetters(["isAdmin"])
  },
  methods: {
    ...mapActions([
      "deleteExamRegistrationAction",
      "updateExamRegistrationPaidAction",
      "updateExamRegistrationCcAction",
      "updateExamRegistrationCreditAction",
      "getSchoolYearsAction",
      "setSchoolYearAction"
    ]),
    getCartItems() {
      let cartItems = [];

      var childrenLength = this.$store.state.account.children.length;
      for (var i = 0; i < childrenLength; i++) {
        var examRegistrationLength = this.$store.state.account.children[i]
          .examRegistrations.length;
        for (var j = 0; j < examRegistrationLength; j++) {
          if (
            !this.$store.state.account.children[i].examRegistrations[j].isPaid
          ) {
            cartItems.push(
              this.$store.state.account.children[i].examRegistrations[j]
            );
          }
        }
      }
      return cartItems;
    },
    getChildName(childId) {
      const name = this.account.children.find(({ id }) => id === childId);
      if (name) {
        return name.childFirstName + " " + name.childLastName;
      }
      return "(not found)";
    },
    calculateTotals() {
      let subTotal = 0;
      const cartItems = this.getCartItems();
      cartItems.forEach(item => {
        item.feeAmount = this.getExamFeeSchoolYear(
          item.gradeLevel,
          item.isRetry,
          item.schoolYearId
        );
        subTotal = subTotal + item.feeAmount;
        console.log("item in calc", item);
      });
      this.subTotalAmount = subTotal;
      this.hstAmount = subTotal * (parseInt(this.hstPercent, 10) / 100);
      this.totalAmount = subTotal + this.hstAmount;
      return this.totalAmount;
    },
    labelTotal(value) {
      return "Please enter " + value.toFixed(2);
    },
    async deleteItem(item) {
      if (confirm("Remove Exam Registration from cart?")) {
        this.$store.state.fullScreenLoading = true;
        const deleteExamRegistrationModel = {
          accountId: this.account.id,
          childId: item.childId,
          examRegistrationId: item.id
        };
        try {
          await this.deleteExamRegistrationAction({
            model: deleteExamRegistrationModel,
            token: this.$store.state.token
          });
          // write a message
          console.log("delete done");
        } catch (err) {
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
        this.$store.state.fullScreenLoading = false;
      }
    },
    async attachForm() {
      try {
        this.payments = window.Square.payments(process.env.VUE_APP_SQUARE_APP_ID, process.env.VUE_APP_SQUARE_LOCATION_ID);
        this.card = await this.payments.card();
        await this.card.attach('#sq-card');
        this.loading = false;
      }
      catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }      
    },
    async detachForm() {
      try {
        await this.card.detach();
      }
      catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }      
    },    
    async applyCredit() {
      console.log("apply credit");
      try {
        const ids = this.getCartItems().map(a => a.id);
        const feeAmounts = this.getCartItems().map(a => a.feeAmount);
        const model = {
          adminId: 0,
          adminName: "",
          accountId: this.$store.state.account.id,
          examRegistrationIds: ids,
          feeAmounts: feeAmounts,
          amount: this.totalAmount,
          notes: ""
        };
        if (this.isAdmin) {
          model.adminId = this.$store.state.user.id;
          model.adminName = this.$store.state.user.firstName;
        }
        console.log("model", model);
        await this.updateExamRegistrationCreditAction({
          model: model,
          token: this.$store.state.token
        });
        this.$router.push({
          name: "Transactions"
        });
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
      this.applyCreditDialog = false;
    },

    async markAsPaid() {
      console.log("im mark as paid");
      try {
        const ids = this.getCartItems().map(a => a.id);
        const feeAmounts = this.getCartItems().map(a => a.feeAmount);
        const model = {
          adminId: this.$store.state.user.id,
          adminName: this.$store.state.user.firstName,
          accountId: this.$store.state.account.id,
          examRegistrationIds: ids,
          feeAmounts: feeAmounts,
          amount: this.totalAmount,
          accountCredit: this.accountCredit,
          notes: this.notes
        };
        console.log("model", model);
        await this.updateExamRegistrationPaidAction({
          model: model,
          token: this.$store.state.token
        });
        this.$router.push({
          name: "Transactions"
        });
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
      this.dialog = false;
    },

    //square payment old
    // requestCardNonce: function(event) {
    //   this.loading = true;
    //   try {
    //     // Don't submit the form until SqPaymentForm returns with a nonce
    //     event.preventDefault();
    //     // Request a nonce from the SqPaymentForm object
    //     this.paymentForm.requestCardNonce();
    //   } catch (err) {
    //     this.loading = false;
    //     this.$store.state.error = this.errorMessage(err);
    //     this.$store.state.snackbar = true;
    //     console.log(err);
    //   }
    // },
    
    //square payment new
    async processPaymentV2(event) {
      this.loading = true;
      try {
          event.preventDefault();
          const tokenResult = await this.card.tokenize();
          if (tokenResult.status === 'OK') {
            const token = tokenResult.token;
            this.postCardPayment(token);
          } else {
            console.error(tokenResult.errors);
          }
      } catch (err) {
        this.loading = false;
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }      
    },
    async postCardPayment(nonce) {
      console.log("im here outside with", nonce);
      const ids = this.getCartItems().map(a => a.id);
      const feeAmounts = this.getCartItems().map(a => a.feeAmount);

      const model = {
        sourceId: nonce,
        amount: this.totalAmount,
        accountCredit: this.accountCredit == null ? 0 : this.accountCredit,
        userId: this.$store.state.user.id,
        accountId: this.$store.state.account.id,
        examRegistrationIds: ids,
        feeAmounts: feeAmounts
      };
      // var result = dataService.payCart(model, this.$store.state.token);
      //console.log("the cc result", result);

      console.log("postCardPayment model", model);

      try {
        await this.updateExamRegistrationCcAction({
          model: model,
          token: this.$store.state.token
        });
        this.$router.push({
          name: "Transactions"
        });
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }

      this.loading = false;
    },
    cancelPay() {
      this.payDialog = false;
      this.loading = false;
    },
    getAccountCredit(accountCredit) {
      this.accountCredit = accountCredit;
    },
    async loadSchoolYears() {
      try {
        await this.getSchoolYearsAction();
        if (this.$store.state.schoolYears == null) {
          this.logout();
          this.$router.go();
        }
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    },
    getExamFeeSchoolYear(gradeLevel, isRetry, schoolYearId) {
      const schoolyear = this.schoolYears.find(s => s.id === schoolYearId);
      const examFee = this.examFees.find(e => e.gradeLevel === gradeLevel);
      if (examFee) {
        let amount = isRetry ? examFee.retryFee : examFee.regularFee;
        if (
          schoolyear.lateFeeDate &&
          Number(new Date()) > Number(new Date(schoolyear.lateFeeDate))
        ) {
          amount = amount + examFee.lateFee;
        }
        return amount;
      }
      return 0;
    }
  }
};
</script>
